import { merge } from '@bingads-webui-universal/primitive-utilities';
import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';


const {
  columnChooserStyle,
  getColumnChooserOverrideStyle,
} = ComponentSettings;

export const getStyle = (components, { palette }) => ({
  columnChooser: merge(
    {},
    columnChooserStyle,
    getColumnChooserOverrideStyle(palette),
    {
      '& .column-chooser .panel': {
        boxShadow: 'none',
        padding: 0,
        marginTop: '24px',
        marginLeft: '32px',
        marginBottom: '0px',
        backgroundColor: 'white',
        '& .panel-heading': {
          backgroundColor: 'white',
          padding: 0,
          marginTop: '0',
          '& .panel-title': {
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '27px',
          },
        },
        '& .panel-body': {
          lineHeight: '19px',
          paddingLeft: 'unset',
          marginBottom: '18px',
          fontSize: '14px',
          '& hr': {
            margin: 0,
            borderTop: '0px',
          },
        },
        '& .panel-footer': {
          borderTop: '1px solid #edebe9',
          marginTop: 0,
          paddingTop: '16px',
          paddingLeft: '0px',
          paddingBottom: '16px',
          backgroundColor: 'white',
          '& .btn': {
            marginRight: '8px',
          },
        },
      },
    }
  ),
});
